import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import MetaData from "@/common/components/MetaData"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"

import Footer from "@/containers/common/FooterNew"

import NavbarNew from "@/containers/common/NavbarNew"
import styled from "styled-components"
import { BGWrapper, theme } from "@/common/Mixin"
import LazyLoadComponent from "@/common/components/LazyLoadComponent"

const Fade = require("react-reveal/Fade")
const ContactUs = () => {
  const { t } = useTranslation("contactUs")

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/contact-us"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/contact-us"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/contact-us"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/contact-us"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <BGWrapper></BGWrapper>
      <LayoutWrapper>
        <FormWithDescWrapper>
          <ContainerWrapper>
            <Fade bottom>
              <TitleWrapper className="title">
                {t("contactUs.title")}
              </TitleWrapper>
              <SloganWrapper>{t("contactUs.slogan")}</SloganWrapper>
              <DescWrapper className="body">
                {t("contactUs.description")}
              </DescWrapper>
            </Fade>
          </ContainerWrapper>
          <FormWrapper>
            <LazyLoadComponent
              skeletonProps={{
                width: "75%"
              }}
              props={{ page: "contact-us" }}
              component={() =>
                import("@/common/components/ContactUs/ContactUsForm")
              }
            />
          </FormWrapper>
        </FormWithDescWrapper>
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["contactUs", "common"]))
  }
})

export default ContactUs

const LayoutWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr;
`

const FormWithDescWrapper = styled.section`
  display: flex;
  padding: 15vh 10vw;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  @media (${theme.lg}) {
    flex-direction: column;
  }
`

const ContainerWrapper = styled.div`
  display: flex;
  width: 40%;
  gap: 32px;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  @media (${theme.lg}) {
    width: 100%;
  }
`

const FormWrapper = styled.div`
  width: 60%;
  @media (${theme.lg}) {
    width: 100%;
  }
`

const TitleWrapper = styled.div`
  color: ${theme.color.primary};
`

const SloganWrapper = styled.h2`
  color: ${theme.color.textContrast};
`

const DescWrapper = styled.span`
  color: ${theme.color.textDisabled};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 25.6px */
  letter-spacing: 0.16px;
`
